/** Preset accent colors for setup store identity (maquette chips). */
export const SETUP_STORE_COLOR_PRESETS = [
  '#4edea3',
  '#3B82F6',
  '#A855F7',
  '#EC4899',
  '#F59E0B',
] as const;
